import { connect } from 'react-redux';

import type { DragName } from '../../ducks/dragged_items/constants';
import {
  setDraggedItems,
  setDropTargetId,
} from '../../ducks/dragged_items/slice';
import { denormalizeSearchItem } from '../../ducks/search/normalizers';
import type { AppState } from '../../store/types';

const mapStateToProps = (state: AppState, props: { name: DragName }) => {
  const dropTargetId = state.draggedItemsReducer.targets[props.name];
  return {
    draggedItems: state.draggedItemsReducer.items[props.name] || [],
    dropTargetId,
    dropTargetElement: dropTargetId
      ? denormalizeSearchItem(state.entities, dropTargetId)
      : undefined,
    editSortMode: state.pages.collection.editSortMode,
  };
};

export default connect(mapStateToProps, {
  setDraggedItems,
  setDropTargetId,
});
